import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Address } from 'ish-core/models/address/address.model';

/**
 * The Address Component displays an address. The readout is country-dependent.
 *
 * @example
 * <ish-address
 *   [address]="order.invoiceToAddress" [displayEmail]="true"
 * ></ish-address>
 */
@Component({
  selector: 'ish-address',
  templateUrl: './address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class AddressComponent {
  /**
   * The Address to be displayed.
   *
   */
  readonly address = input.required<Address>();

  /**
   * If set to true, the email is displayed as part of the address.
   *
   */
  readonly displayEmail = input(false);
}
